const NoticeManage = () =>
  import('@/views/main/wechatMgmt/noticeManage/NoticeManage.vue')
export default {
  path: '/main/wechatMgmt/noticeManage',
  name: 'NoticeManage',
  component: NoticeManage
}
